import '../../steps/styles.less';

import React from 'react';
import classNames from 'classnames';

export function SideImageContainer({
  sideImage,
  children,
  decorationComponent,
  whiteBackground,
}) {
  return (
    <div
      className={classNames('sideimage-container', {
        whitebg: !!whiteBackground,
      })}>
      {/* Left image */}
      <div className="sideimage">
        <img src={sideImage} />
      </div>

      {/* Right side */}
      <div className="bg-deco-container">
        <div className="content">{children}</div>
        {decorationComponent}
      </div>
    </div>
  );
}